import Panorama from "./panorama";

class BackgroundLayer {
    constructor(rootObject) {
        this._rootObject = rootObject;

        this._panorama = new Panorama();
        this._rootObject.add(this._panorama.object);

        this._type = "none";
        this._opacity = 1;
    }

    get opacity() { return this._opacity; }

    set opacity(value) {
        this._opacity = value;
        this._panorama.opacity = value;
    }

    setRenderOrder(order) { this._panorama.renderOrder = order; }

    setBackground({ type = "none", texture = null }) {
        this._type = type;
        this._panorama.object.visible = type === "panorama";

        if (type === "panorama") this._panorama.setTexture(texture);
    }
}

export default BackgroundLayer;
export { BackgroundLayer };
